import { h, Fragment } from 'preact'
import { memo } from 'preact/compat'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import RadioBox from '../RadioBox'
import { useTranslations } from '../../../hooks/useTranslations'
import './styles.scss'

const SelectCard = ({
  title,
  logo,
  subLogo = () => {},
  subTitle,
  totalPrice,
  children,
  name,
  value,
  onClick = () => {},
  isChecked = false,
  className = '',
  inputName,
}) => {
  const classNames = classnames('select-button', 'select-card', className, {
    selected: isChecked,
    outlined: isChecked,
  })

  const l10n = useTranslations()
  const label = (
    <>
      <div className="select-card__title">
        {logo ? (
          <>
            <img src={logo} alt={name} className="select-button__logo" />
            {subLogo(l10n)}
          </>
        ) : (
          title
        )}
      </div>
      <div className="select-card__subtitle">{subTitle}</div>
    </>
  )

  return (
    <figure
      className={`${classNames} card clickable level-1`}
      tabIndex="0"
      onKeyDown={e => {
        if (e.code === 'Space') {
          e.preventDefault()
          e.target.value = name
          onClick(e)
        }
      }}
      data-testid={`card-figure-${value}`}
    >
      <RadioBox
        label={label}
        subTitle={subTitle}
        totalPrice={totalPrice}
        name={name}
        inputProps={{
          id: `${name}-input`,
          name: inputName,
          value,
          checked: isChecked,
          onClick,
          'data-testid': `card-${value}`,
        }}
      >
        {children}
      </RadioBox>
    </figure>
  )
}

SelectCard.propTypes = {
  children: PropTypes.element,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onClick: PropTypes.func,
  isChecked: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subTitle: PropTypes.string,
  totalPrice: PropTypes.string,
  logo: PropTypes.string,
  subLogo: PropTypes.func,
  className: PropTypes.string,
  inputName: PropTypes.string,
}

export default memo(SelectCard)
